import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/gallery-pattern-icon.svg")